module.exports = __webpack_public_path__ + "static/media/Workplace_closing_delay.db74146e.svg";